import { ThemeEvents, VariantUpdateEvent } from '@theme/events';
import { morph } from '@theme/morph';

class PayPo extends HTMLElement {
  connectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.addEventListener(ThemeEvents.variantUpdate, this.updatePayPo);
  }

  disconnectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.removeEventListener(ThemeEvents.variantUpdate, this.updatePayPo);
  }

  /**
   * Updates the visibility of PayPo.
   * Remember to add .js file to scripts.liquid
   * @param {VariantUpdateEvent} event - The variant update event.
   */
  updatePayPo = (event) => {
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (event.target instanceof HTMLElement && event.target.dataset.productId !== this.dataset.productId) {
      return;
    }

    const newPayPo = event.detail.data.html.querySelector('pay-po');

    if (!newPayPo) return;

    morph(this, newPayPo, { childrenOnly: true });
  };
}

if (!customElements.get('pay-po')) {
  customElements.define('pay-po', PayPo);
}
